import { ElementType } from 'react';
import { Box, Switch, Typography } from '@mui/material';

interface ThemeSwitchProps {
	darkMode: boolean;
	handleThemeToggle: () => void;
}

const ThemeSwitch: ElementType<ThemeSwitchProps> =
	({darkMode, handleThemeToggle}) => {

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
			<Typography variant="body2">Light</Typography>
			<Switch
				checked={darkMode}
				onChange={handleThemeToggle}
				color="default"
				size="small"
			/>
			<Typography variant="body2">Dark</Typography>
		</Box>
	);
}

export default ThemeSwitch;
